import React, { createContext, useContext, useEffect, useReducer } from 'react';

import useLocalStorage from '../hooks/useLocalStorage';

const ApplicationStateContext = createContext();
const ApplicationDispatchContext = createContext();

const reducer = (state, { type }) => {
  switch (type) {
    case 'HIDE_COOKIE_NOTICE':
      return {
        ...state,
        showCookieNotice: false,
      };
    default:
      throw new Error(`Invalid action: ${type}`);
  }
};

const ApplicationProvider = ({ children }) => {
  const [appState, saveAppState] = useLocalStorage(
    'graphcms-com',
    JSON.stringify({
      showCookieNotice: true,
    })
  );
  const [state, dispatch] = useReducer(reducer, JSON.parse(appState));

  function dismissCookieNotice() {
    dispatch({ type: 'HIDE_COOKIE_NOTICE' });
  }

  useEffect(() => {
    saveAppState(JSON.stringify(state));

    if (process.env.NODE_ENV === 'production')
      window.Intercom('update', {
        hide_default_launcher: state.showCookieNotice,
        custom_launcher_selector: '.open_intercom',
      });
  }, [state, saveAppState]);

  return (
    <ApplicationStateContext.Provider
      value={{
        ...state,
      }}
    >
      <ApplicationDispatchContext.Provider
        value={{ dispatch, dismissCookieNotice }}
      >
        {children}
      </ApplicationDispatchContext.Provider>
    </ApplicationStateContext.Provider>
  );
};

const useApplicationState = () => {
  const context = useContext(ApplicationStateContext);

  if (!context)
    throw new Error(
      'useApplicationState must be used within a ApplicationProvider'
    );

  return context;
};

const useApplicationDispatch = () => {
  const context = useContext(ApplicationDispatchContext);

  if (!context)
    throw new Error(
      'useApplicationDispatch must be used within a ApplicationProvider'
    );

  return context;
};

export { ApplicationProvider, useApplicationState, useApplicationDispatch };
